const frontendURL = '/cat/locality/';
const backendURL = '/api/references/locality/';
const name = 'Населений пункт';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
